import { TextReveal } from "./TextReveal";

export function SectionHeader({ number, title }) {
  return (
    <div className="flex flex-col gap-4 md:flex-row md:items-center md:gap-6">
      <div className="flex items-center gap-4 md:gap-6">
        <TextReveal>
          <div className="flex items-center gap-3 md:gap-4">
            <span className="text-[40px] md:text-[60px] leading-[60px] text-[#fd5b38]">
              {number}
            </span>
            <div className="h-px w-8 md:w-12 bg-[#fd5b38]" />
          </div>
        </TextReveal>
      </div>
      <TextReveal delay={0.1}>
        <h2 className="text-white text-[28px] md:text-[36px] leading-[40px]">
          {title}
        </h2>
      </TextReveal>
    </div>
  );
}
